"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRootNode = exports.getParentId = exports.GUIDED_EDIT_MODE = exports.NORMAL_EDIT_MODE = exports.UNKNOWN_EDIT_MODE = void 0;
const lodash_1 = __importDefault(require("lodash"));
exports.UNKNOWN_EDIT_MODE = 'unknown';
exports.NORMAL_EDIT_MODE = 'normal';
exports.GUIDED_EDIT_MODE = 'guided';
exports.getParentId = (node) => (node || {}).parent_id || (node || {}).parent || null;
exports.getRootNode = (nodes) => lodash_1.default.find(nodes, (node) => exports.getParentId(node) === null);
const getRootMeta = (nodes) => nodes && lodash_1.default.get(exports.getRootNode(nodes), ['meta']);
const getEditMode = (flow) => {
    const rootMeta = flow ? getRootMeta(flow.nodes) : null;
    if (!rootMeta) {
        return lodash_1.default.get(flow, 'edit_mode', exports.UNKNOWN_EDIT_MODE);
    }
    const rootEditMode = lodash_1.default.get(flow, ['temporaryEditMode'], rootMeta.edit_mode);
    return rootEditMode ? rootEditMode : exports.NORMAL_EDIT_MODE;
};
exports.default = getEditMode;
